export default import.meta.ROLLUP_FILE_URL_aKo4wVjMjV9S8rY28E5Mvg;